'use client';

interface AuthProviderProps {
  children: React.ReactNode;
}

/**
 * Auth provider for Better Auth.
 *
 * Better Auth manages sessions via HTTP-only cookies and does not require
 * a React context provider. This component is kept as a passthrough wrapper
 * to preserve the existing component tree structure and allow future
 * auth-related context additions (e.g., session refresh triggers).
 */
export function AuthProvider({ children }: AuthProviderProps) {
  return <>{children}</>;
}
